/**
 * The LabelFlow logo.
 *
 * Vector, not the old 21KB PNG: one asset cannot be crisp at both 24px and
 * 48px, cannot take the theme's colours, and shipped an emerald wordmark that
 * sat at poor contrast on the light theme.
 *
 * The mark is a selection marquee with its TOP-RIGHT CORNER LEFT OPEN, and a
 * stroke that starts as a check and leaves through the gap — label, then flow.
 * The open corner is also what keeps it readable small: a closed frame crowds
 * the arrow head, which turns to mush below ~24px.
 *
 * The wordmark is live text in the app's own font, two-tone so the accent lands
 * on the half that carries the name. It is real text, so it scales, stays
 * selectable and is what a screen reader announces.
 *
 *   <Logo size={26} />                  mark + wordmark (header, auth cards)
 *   <Logo size={32} wordmark={false} /> mark alone
 *
 * `size` is the MARK's px size; the wordmark is derived from it. Colours come
 * from tokens via `.lf-logo` in theme-overrides.css — never hardcode them here.
 * The app-icon form of this mark (a solid tile, no brackets, for a favicon at
 * 16px) is public/favicon.svg; change the two together.
 */
const Logo = ({ size = 26, wordmark = true, className = '', title = 'LabelFlow' }) => (
  <span
    className={`lf-logo${className ? ` ${className}` : ''}`}
    style={{ '--lf-logo-size': `${size}px` }}
  >
    <svg
      className="lf-logo__mark"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth="3.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      /* With the wordmark present the text already says the name; a second
         announcement of it would just be noise. */
      role={wordmark ? undefined : 'img'}
      aria-label={wordmark ? undefined : title}
      aria-hidden={wordmark ? 'true' : undefined}
      focusable="false"
    >
      <path d="M4 11.5V7.6A3.6 3.6 0 0 1 7.6 4H11.5" />
      <path d="M28 20.5V24.4A3.6 3.6 0 0 1 24.4 28H20.5" />
      <path d="M11.5 28H7.6A3.6 3.6 0 0 1 4 24.4V20.5" />
      <path d="M9.6 17.4L14 21.8L26 8.8" />
      <path d="M21.2 8.8H26V13.4" />
    </svg>
    {wordmark && (
      <span className="lf-logo__word">
        <span className="lf-logo__word-label">Label</span>
        <span className="lf-logo__word-flow">Flow</span>
      </span>
    )}
  </span>
);

export default Logo;
